import React, { useEffect } from 'react'
import './HomeComponent.scss'
import Layout from '../../../layouts/Layout'
import { Image, Header } from 'semantic-ui-react'
import BravePartners from '../BravePartners/BravePartners'
import ArticleSection from '../ArticleSection/ArticleSection'
import BraveNewsletter from '../BraveNewsletter'

import homeimage2 from '../../../addons/images/homeimage2.jpg'
import homeimage3 from '../../../addons/images/homeimage3.jpg'
import homeimage4 from '../../../addons/images/homeimage4.jpg'
import mainLogo from '../../../addons/images/BRaVE-colors.png'

const homeComponent = (props) => {
  useEffect(() => {
    props.getIP()
  }, [])

  useEffect(() => {
  }, [props.ip])

    return (
      <Layout isMain>
        <div className='imageHeader'>
          <Image src={mainLogo} style={{ width: '40%', minWidth: 200 }}/>
          <Header as='h2' className='mainHeader'>Building Resilience Against Violent Extremism and Polarisation</Header>
        </div>
        <ArticleSection
          title={'About BRaVE'}
          subtitle={'Learn more about what we do'}
          link={'/about/aboutBrave'}
          hasTwitter
        >
          <p>
            The BRaVE project is led by the European University Institute in Florence, Italy and made up of a
            consortium of six other partners from across Europe (three civil society organisations and three
            universities). It aims to bring together a broad range of expertise from those researching and
            working to build resilience against violent extremism and polarisation.
          </p>
        </ArticleSection>
        <ArticleSection
          title={'Interactive map'}
          subtitle={'Discover relevant projects, studies and polices'}
          link={'/map'}
          image={homeimage2}
          reverse
        >
          <p>
            The Digital Map helps you easily discover relevant counter-extremism projects, studies and policies on a
            country-by-country basis. We have integrated findings from both our academic research and European-wide
            surveys to highlight relevant resources useful in understanding counter-extremism responses.
          </p>
        </ArticleSection>
        <ArticleSection
          title={'Polarisation indicators toolkit'}
          subtitle={'Indicator Toolkit for developing good practice'}
          link={'/toolkit'}
          image={homeimage3}
          hideLearnMore
        >
          <p>
            The Polarisation Indicators Toolkit helps you find out about current good practices used in tackling
            polarisation and extremism. The toolkit is designed for use by local and national authorities, as
            well as interested groups of citizens and researchers.
          </p>
        </ArticleSection>
        <BraveNewsletter />
        <ArticleSection
          title={'BRaVE Fair'}
          subtitle={'Supporting innovative resilience projects'}
          link={'/braveFair'}
          image={homeimage4}
          reverse
        >
          <p>
            The BRaVE Fair brings together different innovative grassroots projects in the field of arts and
            sports-based interventions for channelling political frustration, particularly amongst youth,
            increasing the perception of commonalities and shared histories, and ultimately counteracting polarisation.
          </p>
        </ArticleSection>
        <BravePartners />
      </Layout>
    )
}

export default homeComponent



// WEBPACK FOOTER //
// ./src/components/HomeComponent/components/HomeComponent.js